import * as actions from '../Actions/Questions';

export const questionsReducer = (state = {}, action) => {
      switch (action.type) {
          case actions.GET_DATA_REQUESTED:
              return { ...state, isLoading: true };
          case actions.GET_DATA_DONE:
              return { ...state, isLoading: false, questions: action.payload };
          case actions.GET_DATA_FAILED:
              return { ...state, isLoading: false, isError: true, error: action.payload };
          default:
              return state;
      }
 };

